import axios, {AxiosResponse, AxiosError} from 'axios';
import {HttpRequestHelper} from "../HttpRequestHelper";
import * as util from 'util';
import {JAPIExternalPuzzleGetRecordResponse} from "platform_common/types/api/JAPIExternalPuzzle";
import {Config} from "../../Config";

/**
 * Client side implementation for hitting external API
 * for puzzle
 */
export class CAPIExternalPuzzle {

    public static _basePath:string = Config.APIInternalBasePathPrefix + "/external";

    /**
     * Get specific Puzzle Record.
     *
     * @param id
     */
    public static async getRecord(id:number):Promise<AxiosResponse<JAPIExternalPuzzleGetRecordResponse>|AxiosError> {

        try {
            // start with template URL for this call
            let urlTemplate:string = util.format('%s%s/puzzle/id/{id}', HttpRequestHelper.getAPI1BaseUrl(), CAPIExternalPuzzle._basePath);

            // add parameters to final url
            let finalUrl:string = urlTemplate
                .replace('{id}', id.toString());

            // get request options
            let requestOptions:any = HttpRequestHelper.buildGetHttpRequestOptions(finalUrl);

            // send request and get response
            return await axios(requestOptions);
        }
        catch (e) {
            return <AxiosError><any>e;
        }
    }
}
